<template>
  <item-nav :id="$attrs['id']">
    <item-nav-item :label="$t('layout.nav.admin.userNav.overview')" link="users" />
    <item-nav-group v-if="!isEmpty(users)" :open="true" :label="$t('layout.nav.admin.userNav.users')">
      <template v-for="user in users" v-if="!user.deleted">
        <item-nav-group-item :label="getName(user.userName)" :params="routeParams(user.id)" :key="user.id" link="user" />
      </template>
    </item-nav-group>

    <item-nav-group v-if="!isEmpty(deletedUsers) && hasRole('ROLE_SYSADMIN')" :label="$t('layout.nav.admin.userNav.deletedUsers')">
      <item-nav-group-item v-for="user in deletedUsers"
                           :label="getName(user.userName)"
                           :params="routeParams(user.id)"
                           :key="user.id"
                           link="user" />
    </item-nav-group>

  </item-nav>
</template>

<script>

import { cloneDeep, isNil, isEmpty, keyBy } from 'lodash';
import ItemNavGroup from '../ItemNavGroup';
import ItemNavGroupItem from '../ItemNavGroupItem';
import HotelmeisterMixin from '../../../../../mixins/HotelmeisterMixin';

export default {
  name: 'UserNav',
  components: { ItemNavGroupItem, ItemNavGroup },

  mixins: [HotelmeisterMixin],
  props: [],

  data() {
    return {
      users: [],
    };
  },

  computed: {
    deletedUsers: function () {
      return this.users.filter(it => it.deleted === true);
    },
  },

  created: function () {
    this.updateUsers();

    this.$serviceBus.$on('user.list', (data) => {
      if (isNil(data)) {
        this.updateUsers();
      } else {
        this.users = data;
      }
    });
  },

  mounted: function () {
    this.$emit('widenav', true);
  },

  methods: {
    updateUsers() {
      this.axios.get(this.serviceUrls.user.list(this))
        .then((response) => {
          this.users = response.data.data;
        });
    },
    getName(name) {
      if (isNil(name)) return '-';

      return name;
    },
    routeParams(userId) {
      return {
        userId: userId,
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/admin/UserNav.vue